import LandmarkRenderer from '../utilities/layouts/landmark_renderer';

export default class Landmark {
  // eslint-disable-next-line max-params
  constructor(id, rotation, width, height, topLeftX, topLeftY, svgURL, label, filename) {
    this.id = id;
    this.rotation = rotation;
    this.width = width;
    this.height = height;
    this.topLeftX = topLeftX;
    this.topLeftY = topLeftY;
    this.svgURL = svgURL;
    this.label = label;
    this.filename = filename;
    this.key = `landmark-${this.id}`;
  }

  static fromAttributes({ id, rotation, width, height, top_left_x, top_left_y, svg_url, label, filename }) {
    return new Landmark(
      id,
      rotation,
      width,
      height,
      top_left_x,
      top_left_y,
      svg_url,
      label,
      filename
    );
  }

  serialize() {
    return {
      rotation: this.rotation,
      width: this.width,
      height: this.height,
      top_left_x: this.topLeftX,
      top_left_y: this.topLeftY,
      svg_url: this.svgURL,
      label: this.label,
    }
  }

  renderOn(canvas, readOnly = false) {
    this.renderer = new LandmarkRenderer(this, readOnly);
    this.renderer.setCanvas(canvas).render();
  }

  clone() {
    const offset = 0.1;
    return new Landmark(
      null,
      this.rotation,
      this.width,
      this.height,
      this.topLeftX + offset,
      this.topLeftY + offset,
      this.svgURL,
      this.label,
      this.filename
    );
  }

  remove() {
    this.renderer.remove();
  }

  setLabel(label) {
    this.label = label
    this.renderer.setLabel(label);
  }

  topRightX() {
    return this.width + this.topLeftX;
  }

  bottomLeftY() {
    return this.height + this.topLeftY;
  }

  setActive() {
    this.renderer.setActive();
  }

}
